import React from 'react'
import agent from '../agent'
import UserList from './widgets/UserList';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import { DatePicker, Menu, Dropdown, Button, Icon, } from 'antd';
import 'antd/dist/antd.css';
import moment from 'moment';
import * as _ from 'lodash'
import role from '../util/role'
import {
  USER_LIST_PAGE_LOADED,
  USER_LIST_NEXT_PAGE_LOADED,
  USER_LIST_SEARCH_LOADED,
  UPDATE_FIELD_SEARCHTERM,
  USER_LIST_PAGE_UNLOADED,
  CHANGE_DATE_STRINGS,
  USER_LIST_EXPORT,
  CLEAR_PROPS,
  VIEW_REPORTS_URL
} from '../constants/actionTypes'
import Loading from './widgets/Loading'
const { RangePicker } = DatePicker;
const dateFormat = 'YYYY/MM/DD';


const mapStateToProps = state => ({
  ...state.userList,
  appName: state.common.appName,
  token: state.common.token,
  date_from: state.common.date_from,
  date_to: state.common.date_to,
  inProgress: state.common.inProgress,
  currentUser: state.common.currentUser,
});

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, pageIndex, terms, status, date_from, date_to) => {
    dispatch({ type: USER_LIST_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, status, date_from, date_to })
  },
  onLoadNextPage: (payload, pageIndex, terms, status, date_from, date_to) => {
    dispatch({ type: USER_LIST_NEXT_PAGE_LOADED, payload, currentPage: pageIndex, searchTerm: terms, status, date_from, date_to })
  },
  onSearchUsers: (payload, pageIndex, terms, status, date_from, date_to) => {
    dispatch({ type: USER_LIST_SEARCH_LOADED, payload, currentPage: pageIndex, searchTerm: terms, status, date_from, date_to })
  },
  onChangeSearchTerm: value =>
    dispatch({ type: UPDATE_FIELD_SEARCHTERM, key: 'searchTerm', value }),
  onChangeDateStrings: (date_from, date_to) =>
    dispatch({ type: CHANGE_DATE_STRINGS, date_from, date_to }),
  onUnload: () =>
    dispatch({ type: USER_LIST_PAGE_UNLOADED }),
  onExportCsv: (payload) =>
    dispatch({ type: USER_LIST_EXPORT, payload }),
  onClearCsvProps: () => dispatch({ type: CLEAR_PROPS }),
});

class Users extends React.Component {
  constructor() {
    super();
    this.handlePageChanged = this.handlePageChanged.bind(this);
    this.changeSearchTerm = (ev) => this.props.onChangeSearchTerm(ev.target.value)

    this.handleAllSelected = this.handleChangeStatus.bind(this, 'all')
    this.handleNotverifiedSelected = this.handleChangeStatus.bind(this, 'notverified')
    this.handleVerifiedSelected = this.handleChangeStatus.bind(this, 'verified')

    this.searchUsers = () => ev => {
      ev.preventDefault()
      const pageIndex = 1;
      const terms = this.props.searchTerm || ''
      const status = this.props.status || 'all'
      const date_from = this.props.date_from || ''
      const date_to = this.props.date_to || ''
      const payload = agent.Users.all(pageIndex, terms, status, date_from, date_to)
      this.props.onSearchUsers(payload, pageIndex, terms, status, date_from, date_to)
    }
    this.exportCsv = (filter) => ev => {
      ev.preventDefault()
      const date_from = this.props.date_from || ''
      const date_to = this.props.date_to || ''
      this.props.onExportCsv(agent.Users.export(date_from, date_to, filter))
    }
  }
  componentWillMount() {
    const pageIndex = 1;
    const terms = ''
    const status = 'all'
    const date_from = ''
    const date_to = ''
    const payload = Promise.all([
      agent.Users.all(pageIndex, terms, status, date_from, date_to),
      agent.Common.getUsersReports(),
      agent.Tokens.getPrimeTokens()
    ])
    this.props.onLoad(payload, pageIndex, terms, status, date_from, date_to);

  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.csvData) {
      var data = new Blob([nextProps.csvData], { type: 'text/csv' });
      var csvURL = window.URL.createObjectURL(data);
      var tempLink = document.createElement('a');
      tempLink.href = csvURL;
      tempLink.setAttribute('download', `${new Date()}_users.csv`);
      tempLink.click();
      this.props.onClearCsvProps()
    }
  }
  componentWillUnmount() {
    this.props.onUnload();
  }
  handlePageChanged(newPage) {
    const pageIndex = newPage + 1;
    const terms = this.props.searchTerm || ''
    const status = this.props.status || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const payload = agent.Users.all(pageIndex, terms, status, date_from, date_to)
    this.props.onLoadNextPage(payload, pageIndex, terms, status, date_from, date_to);
  }
  handleChangeStatus(userStatus) {
    const pageIndex = 1;
    const terms = this.props.searchTerm || ''
    const status = userStatus || ''
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const payload = agent.Users.all(pageIndex, terms, status, date_from, date_to)
    this.props.onLoadNextPage(payload, pageIndex, terms, status, date_from, date_to);
  }
  handleChangeDateStrings(dates, dateStrings) {
    // console.log('From: ', dates[0], ', to: ', dates[1]);
    // console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
    // // this.setState({ from: dateStrings[0], to: dateStrings[1] })
    var unixFrom = dateStrings[0] ? moment(dateStrings[0]).format('X') : ''
    var unixTo = dateStrings[1] ? moment(moment(dateStrings[1]).format('YYYY-MM-DD 23:59:59')).format('X') : ''
    this.props.onChangeDateStrings(unixFrom, unixTo)
  }

  handleMenuClick(e) {
    console.log('click', e);
    const date_from = this.props.date_from || ''
    const date_to = this.props.date_to || ''
    const filter = e.key
    this.props.onExportCsv(agent.Users.export(date_from, date_to, filter))
  }
  render() {
    if (!this.props.users) {
      return (
          <Loading />
      )
  }

    const date_from = this.props.date_from ? moment(moment(this.props.date_from * 1000).format('YYYY-MM-DD')) : ''
    const date_to = this.props.date_to ? moment(moment(this.props.date_to * 1000).format('YYYY-MM-DD')) : ''
    const inProgress = this.props.inProgress
    const reports = this.props.reports
    const btc_report_url = _.find(reports, { filter: 'have_btc' }) ? _.find(reports, { filter: 'have_btc' }).location : `#`
    const eth_report_url = _.find(reports, { filter: 'have_eth' }) ? _.find(reports, { filter: 'have_eth' }).location : `#`
    const locked_amount_report_url = _.find(reports, { filter: 'locked_amount' }) ? _.find(reports, { filter: 'locked_amount' }).location : `#`
    const raw_accounts_report_url = _.find(reports, { filter: 'raw_accounts' }) ? _.find(reports, { filter: 'raw_accounts' }).location : `#`
    const other_report_url = _.find(reports, { filter: 'above_all' }) ? _.find(reports, { filter: 'above_all' }).location : `#`
    const primeTokens = this.props.primeTokens || []
    // const primeSymbols = primeTokens.map(i => i.symbol)
    const primeSymbols = primeTokens.map(i => i)
    const menu = (
      <Menu>
        {
          primeSymbols.map(item => {
            return (
              <Menu.Item key={`have_${item.toLowerCase()}`}>
                <a href={_.find(reports, { filter: `have_${item.toLowerCase()}` }) ? _.find(reports, { filter: `have_${item.toLowerCase()}` }).location : `#`}> Have {item}</a>
              </Menu.Item>
            )
          })
        }
        <Menu.Item key="have_btc">
          <a href={btc_report_url}>Have BTC</a>
        </Menu.Item>
        <Menu.Item key="have_eth">
          <a href={eth_report_url}>Have ETH</a>
        </Menu.Item>
        <Menu.Item key="locked_amount">
          <a href={locked_amount_report_url}>Locked Amount</a>
        </Menu.Item>
        <Menu.Item key="raw_accounts">
          <a href={raw_accounts_report_url}>Raw Accounts</a>
        </Menu.Item>
        <Menu.Item key="above_all">
          <a href={other_report_url}> All of the above</a>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className='pane'>
        <span><Link className="buttonTop" to='/users/create'><i className="icon ion-android-add-circle"></i></Link></span>
        {/* <span><Link className="buttonTop" to='#'><i className="icon ion-ios-download-outline" onClick={this.exportCsv()} ></i></Link></span> */}
        {/*role.can(this.props.currentUser.role, VIEW_REPORTS_URL) ?
          (<span>
            <Dropdown overlay={menu} className="ant-dropdown-button" trigger={['click']}>
              <Button>
                {'Download'} <Icon type="download" />
              </Button>
            </Dropdown></span>)
          : null*/}
        <h1>Users list</h1>
        <div className="filters">
          <div className="filterTabs">
            <Link to='/users' className={this.props.status === 'all' ? "selected" : ""} value='all' onClick={this.handleAllSelected}>All users</Link>
            <Link to='/users?status=verified' className={this.props.status === 'verified' ? "selected" : ""} onClick={this.handleVerifiedSelected}>Email verified</Link>
            <Link to='/users?status=notverified' className={this.props.status === 'notverified' ? "selected" : ""} onClick={this.handleNotverifiedSelected}>Not verified</Link>
          </div>
          <div className="filterSearch">
            <RangePicker
              ranges={{ 'This Month': [moment().startOf('month'), moment()], Today: [moment(), moment()] }}
              value={[date_from, date_to]}
              onChange={this.handleChangeDateStrings.bind(this)}
            />
            <input type="text" className="searchBox" placeholder="find user" value={this.props.searchTerm} onChange={this.changeSearchTerm} />
            <button type="submit" onClick={this.searchUsers()}>Find</button>
          </div>
        </div>
        <UserList users={this.props.users} loading={this.props.loading} />
        {
          this.props.users && this.props.users.length > 0 ?
            <Pager
              total={this.props.totalPage || 0}
              current={this.props.currentPage - 1}
              visiblePages={7}
              titles={{ first: '<<', last: '>>' }}
              onPageChanged={this.handlePageChanged.bind(this)}
            />
            : null
        }
      </div >
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// ./src/components/Users.js